import { combineReducers } from "redux";
import AccountReducer from "./account";
import SessionReducer from "./session";
import LoadingReducer from "./loading";
import ModalReducer from "./modal";


const allReducers = combineReducers({
  // add more reducers here
  AccountReducer,
  SessionReducer,
  LoadingReducer,
  ModalReducer
});

const refreshReducers = combineReducers({
  // add more reducers here
  // loadingReducer
});

export {allReducers, refreshReducers};
